import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    header: {},
    content: {
        padding: 0
    },
    tableContainer: {
        maxHeight: 600
    },
    table: {
        [theme.breakpoints.down('md')]: {
            tableLayout: 'fixed'
        },
    },
    td: {
        textAlign: 'center',
        padding: '10px 2px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    tableRow: {
        '&$selected, &$selected:hover': {
            backgroundColor: theme.palette.gray.main
        }
    },
    selected: {},
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        marginLeft: theme.spacing(-1),
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const List = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);

    return (
        <>
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >
                <CardHeader
                    title="Screenshots"
                    className={classes.header}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <Grid container spacing={1}>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            xs={12}
                        >
                            <TableContainer className={classes.tableContainer}>
                                <Table stickyHeader aria-label="sticky table" className={classes.table}>
                                    <colgroup>
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.td}>Site</TableCell>
                                            <TableCell className={classes.td}>Deal</TableCell>
                                            <TableCell className={classes.td}>Date</TableCell>
                                            <TableCell className={classes.td}>Screenshot</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((screenshot, j) => (
                                            <TableRow
                                                hover
                                                key={j}
                                                data-row={j}
                                                classes={{selected: classes.selected}}
                                                className={classes.tableRow}
                                            >
                                                <TableCell className={classes.td}>{screenshot.site}</TableCell>
                                                <TableCell className={classes.td}>{screenshot.deal}</TableCell>
                                                <TableCell className={classes.td}>{screenshot.date}</TableCell>
                                                <TableCell className={classes.td}>
                                                    <a href={`https://ecdi.s3.ap-northeast-2.amazonaws.com/${screenshot.link}`} target="_blank" rel="noopener noreferrer">
                                                        OPEN
                                                    </a>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider/>
            </Card>
        </>
    );
};

List.propTypes = {
    className: PropTypes.string,
    data: PropTypes.array.isRequired,
    onClick: PropTypes.func
};

export default List;
